import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'

export const EmployeeMasterPopup = (props) => {
    return (
        <ModalBasic
            id="companyMaster"
            classParams="!w-[75%] !overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Employee details</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-3 pb-3 border-b border-slate-300'>
                    <div className='input-grp'>
                        <label>Emp. code</label>
                        <TextInput type='number'
                            id='empCode' name='empCode'
                            value={props.employeeObject.empCode}
                            onChange={(event) => props.handleChange(event, 'empCode')}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Emp. group</label>
                        <MultiSelectDropdown
                            className={` ${props.validState?.error?.empGrpId ? "error" : ""}`}
                            options={props.employeeObject.employeeGroups}
                            value={props.employeeObject.empGrpId ? props.employeeObject.employeeGroups.find(x => x.value === props.employeeObject.empGrpId) : 0}
                            onChange={(event) =>
                                props.handleChange(event, 'empGrpName')
                            }
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Employee name:</label>
                        <TextInput type='text'
                            id='empName' name='empName'
                            value={props.employeeObject.empName}
                            handleChange={(event) => props.handleChange(event, 'empName')}
                            className={props.validState?.error?.empName !== undefined ? "error" : ""}
                        />
                    </div>
                </div>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2.5'>
                    <div className='input-grp'>
                        <label>Designation</label>
                        <MultiSelectDropdown
                            className={` ${props.validState?.error?.designationId ? "error" : ""}`}
                            options={props.employeeObject.designations}
                            value={props.employeeObject.designationId ? props.employeeObject.designations.find(x => x.value === props.employeeObject.designationId) : 0}
                            onChange={(event) =>
                                props.handleChange(event, 'Designation')
                            }
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Department</label>
                        <MultiSelectDropdown
                            className={` ${props.validState?.error?.departmentId ? "error" : ""}`}
                            options={props.employeeObject.departments}
                            value={props.employeeObject.departmentId ? props.employeeObject.departments.find(x => x.value === props.employeeObject.departmentId) : 0}
                            onChange={(event) =>
                                props.handleChange(event, "Department")
                            }
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Address:</label>
                        <textarea rows={1} type='text'
                            id='address' name='address'
                            value={props.employeeObject.address}
                            onChange={(event) => props.handleChange(event, 'address')}
                        />
                    </div>
                </div>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2.5'>
                    <div className='input-grp'>
                        <label>Contact no:</label>
                        <TextInput type='number'
                            id='contactNo' name='contactNo'
                            value={props.employeeObject.contactNo}
                            handleChange={(event) => props.handleChange(event, 'contactNo')}
                            className={props.validState?.error?.contactNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Email id:</label>
                        <TextInput type='text'
                            id='email' name='email'
                            value={props.employeeObject.email}
                            handleChange={(event) => props.handleChange(event, 'email')}
                            className={props.validState?.error?.email !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Joining date:</label>
                        <TextInput type='date'
                            id='date' name='date'
                            value={props.employeeObject.joiningDate}
                            handleChange={(event) => props.handleChange(event, 'joiningDate')}
                            className={props.validState?.error?.joiningDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Account no:</label>
                        <TextInput type='number'
                            id='accNo' name='accNo'
                            value={props.employeeObject.accNo}
                            handleChange={(event) => props.handleChange(event, 'accNo')}
                            className={props.validState?.error?.accNo !== undefined ? "error" : ""}
                        />
                    </div>
                </div>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2.5'>
                    <div className='input-grp'>
                        <label>PF no:</label>
                        <TextInput type='number'
                            id='pfNo' name='pfNo'
                            value={props.employeeObject.pfNo}
                            handleChange={(event) => props.handleChange(event, 'pfNo')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>ESIC no:</label>
                        <TextInput type='text'
                            id='esicNo' name='esicNo'
                            value={props.employeeObject.esicNo}
                            handleChange={(event) => props.handleChange(event, 'esicNo')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Basic:</label>
                        <TextInput type='number'
                            id='basic' name='basic'
                            value={props.employeeObject.basic}
                            handleChange={(event) => props.handleChange(event, 'basic')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>HRA:</label>
                        <TextInput type='number'
                            id='hra' name='hra'
                            value={props.employeeObject.hra}
                            handleChange={(event) => props.handleChange(event, 'hra')}
                        />
                    </div>
                </div>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2.5'>
                    <div className='input-grp'>
                        <label>Conv:</label>
                        <TextInput type='number'
                            id='conv' name='conv'
                            value={props.employeeObject.conv}
                            handleChange={(event) => props.handleChange(event, 'conv')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Sp. allow:</label>
                        <TextInput type='number'
                            id='spAllow' name='spAllow'
                            value={props.employeeObject.spAllow}
                            handleChange={(event) => props.handleChange(event, 'spAllow')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Gross salary:</label>
                        <TextInput type='number'
                            id='grossSalary' name='grossSalary'
                            value={props.employeeObject.grossSalary}
                            //handleChange={(event) => props.handleChange(event, 'stateCode')}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>PF:</label>
                        <TextInput type='number'
                            id='pf' name='pf'
                            value={props.employeeObject.pf}
                            //handleChange={(event) => props.handleChange(event, 'stateCode')}
                            disabled
                        />
                    </div>
                </div>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2.5'>
                    <div className='input-grp'>
                        <label>Prof. Tax:</label>
                        <TextInput type='number'
                            id='profTax' name='profTax'
                            value={props.employeeObject.profTax}
                            //handleChange={(event) => props.handleChange(event, 'stateCode')}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>ESIC Amt:</label>
                        <TextInput type='number'
                            id='esicAmt' name='esicAmt'
                            value={props.employeeObject.esicAmt}
                            //handleChange={(event) => props.handleChange(event, 'stateCode')}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>TDS group</label>
                        <MultiSelectDropdown
                            options={props.employeeObject.tdsGroups}
                            value={props.employeeObject.selectedTDSGroups ? props.employeeObject.tdsGroups.find(x => x.value === props.employeeObject.selectedTDSGroups) : 0}
                            onChange={(event) =>
                                props.handleChange(event,
                                    "TDSGroups"
                                )
                            }
                        />
                    </div>
                    <div className='input-grp'>
                        <label>TDS:</label>
                        <TextInput type='number'
                            id='tds' name='tds'
                            value={props.employeeObject.tds}
                            handleChange={(event) => props.handleChange(event, 'tds')}
                        />
                    </div>
                </div>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2.5'>

                    <div className='input-grp'>
                        <label>Acc. sub head:</label>
                        <MultiSelectDropdown
                            className={` ${props.validState?.error?.accSubHeadId ? "error" : ""}`}
                            options={props.employeeObject.generalProducts}
                            value={props.employeeObject.accSubHeadId ? props.employeeObject.generalProducts.find(x => x.value === props.employeeObject.accSubHeadId) : 0}
                            onChange={(event) =>
                                props.handleChange(
                                    event,
                                    "AccSubHead"
                                )
                            }
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Op date:</label>
                        <TextInput type='date'
                            id='opDate' name='opDate'
                            value={props.employeeObject.opDate}
                            handleChange={(event) => props.handleChange(event, 'opDate')}
                            className={props.validState?.error?.opDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Op. balance:</label>
                        <TextInput type='number'
                            id='opBalance' name='opBalance'
                            value={props.employeeObject.opBalance}
                            handleChange={(event) => props.handleChange(event, 'opBalance')}
                            className={props.validState?.error?.opBalance !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Op balance type</label>
                        <MultiSelectDropdown
                            className={` ${props.validState?.error?.opBalanceTypeId ? "error" : ""}`}
                            options={props.employeeObject.types}
                            value={props.employeeObject.types.find(x => x.value === props.employeeObject.opBalanceTypeId)}
                            onChange={(event) =>
                                props.handleChange(
                                    event,
                                    "OpBalanceType"
                                )
                            }
                        />
                    </div>
                </div>
                <div className='item-grp grid grid-cols-4 gap-x-2.5 gap-y-3 items-center'>

                    {/* <div className='input-grp'>
                        <label>Exp. closing:</label>
                        <TextInput type='text'
                            id='expClosing' name='expClosing'
                            value={props.employeeObject.expClosing}
                            handleChange={(event) => props.handleChange(event, 'expClosing')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Exp OP type:</label>
                        <MultiSelectDropdown
                            options={props.employeeObject.types}
                            value={props.employeeObject.selectedExpOPType}
                            onChange={(event) =>
                                props.handleChange(
                                    event,
                                    "EexpOPTypeName"
                                )
                            }
                        />
                    </div> */}
                    <div className='input-grp'>
                        <label>Blood group:</label>
                        {/* <TextInput type='number'
                            id='stateCode' name='stateCode'
                            // value={props.employeeObject.stateCode}
                            onChange={(event) => props.handleChange(event, 'stateCode')}
                        /> */}
                        <MultiSelectDropdown
                            options={props.employeeObject.bloodGroups}
                            value={props.employeeObject.selectedBloodGroups ? props.employeeObject.bloodGroups.find(x => x.value === props.employeeObject.selectedBloodGroups) : 0}
                            onChange={(event) =>
                                props.handleChange(
                                    event,
                                    "BloodGroups"
                                )
                            }
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Birth date</label>
                        <TextInput type='date'
                            id='birthDate' name='birthDate'
                            value={props.employeeObject.birthDate}
                            handleChange={(event) => props.handleChange(event, 'birthDate')}
                        />
                    </div>

                    <div className='input-grp col-span-2'>
                        <label>Remarks:</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.employeeObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                        />
                    </div>
                    <div className='input-grp !inline-flex !gap-[10px]'>
                        <label>Is leave:</label>
                        <input type='CheckBox'
                            className='shadow-none w-[15px] h-[15px]'
                            id='isLeave' name='isLeave'
                            value={props.employeeObject.isLeave}
                            checked={props.employeeObject.isLeave}
                            onClick={(event) => props.handleChange(event, 'isLeave')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Leave date:</label>
                        <TextInput type='date'
                            id='leaveDate' name='leaveDate'
                            value={props.employeeObject.leaveDate}
                            handleChange={(event) => props.handleChange(event, 'leaveDate')}
                        />
                    </div>
                </div>

                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>{props.employeeObject.idEmployee > 0 ? "Update" : "Save"} </button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}
